import { render } from "./CollectionBlockLabel.vue?vue&type=template&id=431eef33&scoped=true&ts=true"
import script from "./CollectionBlockLabel.vue?vue&type=script&lang=ts"
export * from "./CollectionBlockLabel.vue?vue&type=script&lang=ts"

import "./CollectionBlockLabel.vue?vue&type=style&index=0&id=431eef33&lang=scss&scoped=true"

import exportComponent from "/var/www/kun/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-431eef33"]])

export default __exports__